// Toggle do menu mobile.
// Vanilla JS de propósito: este mesmo arquivo pode ser copiado para
// assets/mobile-menu.js de um tema Shopify e referenciado com
// {{ 'mobile-menu.js' | asset_url | script_tag }}, sem alterações.
(function () {
  function init() {
    var toggle = document.querySelector("[data-lk-menu-toggle]");
    var menu = document.querySelector("[data-lk-mobile-menu]");
    if (!toggle || !menu) return;

    toggle.addEventListener("click", function () {
      menu.classList.toggle("is-open");
    });
  }

  if (document.readyState !== "loading") {
    init();
  } else {
    document.addEventListener("DOMContentLoaded", init);
  }
})();
